import { IconInformationFill, IconStatusQueuedFill } from '@saucelabs/ds-icons';
import { Status, StatusProps } from '@saucelabs/ds-status';
import React from 'react';

import { BuildStatus } from '../../graphql/__generated__/graphql';

const FALLBACK: StatusProps = {
  type: 'errored',
  label: 'Unknown',
  icon: <IconInformationFill className="fill-current h-2 w-2 text-orange-600" />,
};

const STATUS_DATA: Record<BuildStatus, StatusProps> = {
  [BuildStatus.Approved]: { type: 'passed', label: 'Accepted' },
  [BuildStatus.Rejected]: { type: 'failed', label: 'Rejected' },
  [BuildStatus.Unapproved]: { type: 'errored', label: 'For review', icon: <IconStatusQueuedFill className="fill-current h-2 w-2 text-orange-600" /> },
  [BuildStatus.Equal]: { type: 'passed', label: 'No changes' },
  [BuildStatus.Empty]: { type: 'completed', label: 'No snapshots' },
  [BuildStatus.Running]: { type: 'running', label: 'Running' },
  [BuildStatus.Errored]: { type: 'errored', label: 'Errored' },
  [BuildStatus.Queued]: { type: 'queued', label: 'Queued' },
};

type Props = {
  buildType: BuildStatus
}

const VisualStatus: React.FC<Props> = ({ buildType }) => {
  const data = STATUS_DATA[buildType] ?? FALLBACK;

  return <Status {...data} />;
};

export default VisualStatus;
